/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SyncResultView } from './syncResultView';

export interface SyncResponse {
  sync_job_id: string;
  results?: SyncResultView[];
}
